import { createContext } from 'react'

const contextPayload = {
  isBuyer: undefined,
  isSeller: undefined,
  isPrivate: undefined,
  userType: undefined
}

const AuthorizationContext = createContext(contextPayload)
AuthorizationContext.displayName = 'authorization-context'

export default AuthorizationContext
